import { useEventStream } from '@/shared/api/useEventStream';
import type { Notification } from '../model/Notification';

interface UseNotificationStreamOptions {
  enabled: boolean;
  onNotification: (notification: Notification) => void;
}

export const useNotificationStream = ({ enabled, onNotification }: UseNotificationStreamOptions) => {
  return useEventStream<Notification>({
    path: '/notifications/stream',
    eventName: 'notification',
    enabled,
    onEvent: onNotification,
  });
};
